import {
  ApplicationConfig,
  FactoryProvider,
  importProvidersFrom,
  inject,
} from '@angular/core';
import {
  NavigationError,
  Router,
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { FlatpickrModule } from 'angularx-flatpickr';

import { routes } from './app.routes';

import { serviceProviders } from './core/providers/services.provider';
import { materialProviders } from './core/providers/material.provider';

import { headerInterceptor } from './core/interceptors/header.interceptor';
import { titleStrategyProvider } from './core/providers/title-strategy.provider';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { provideServiceWorker } from '@angular/service-worker';

export function errorHandlerFactory(router: Router) {
  return () => {
    router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        if (!navigator.onLine) {
          console.warn('[Navigation] Offline navigation error - chunk not cached:', event.error);
          return;
        }
        router.navigate(['/404']);
        console.error(event.error);
      }
    });
  };
}

export const errorHandlerProvider: FactoryProvider = {
  provide: 'ErrorHandler',
  useFactory: errorHandlerFactory,
  deps: [Router],
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withComponentInputBinding(),
      withViewTransitions(),
      withPreloading(PreloadAllModules)
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([
        headerInterceptor,
        loadingInterceptor
    ])),
    provideNativeDateAdapter(),
    errorHandlerProvider,
    // Flatpickr
    importProvidersFrom(FlatpickrModule.forRoot()),
    titleStrategyProvider,
    ...materialProviders,
    ...serviceProviders,
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerImmediately'
    }),
],
};

